import type { CurrentAction } from "./actions";

export const roundNameLineBreakError = "Round names can't contain line breaks.";

// Every character that starts a new line somewhere a round name is printed:
// PHP and JavaScript single-line comments end at \n or \r, and JavaScript also
// ends them at U+2028/U+2029. The Announcement Worksheet's PHP export puts the
// name in such a comment (SP-3027, I08-M03), so a line break there turns the
// rest of the name into code.
const lineBreak = /[\n\v\f\r\u0085\u2028\u2029]/;

/**
 * Why a newly dispatched action may not set this round name, or null when it
 * may (including every action that sets no name). The wire schemas stay
 * permissive so that confirmed history keeps parsing and replaying; the
 * reducer applies this to new actions only.
 */
export function invalidNewRoundNameReason(
  payload: CurrentAction,
): string | null {
  const name = roundNameSetBy(payload);

  if (name != null && lineBreak.test(name)) {
    return roundNameLineBreakError;
  }

  return null;
}

function roundNameSetBy(payload: CurrentAction): string | null {
  switch (payload.type) {
    case "CREATE_ROUND":
      return payload.name;
    case "CREATE_ROUND_WIZARD":
      return payload.round.name;
    case "ROUND_NAME_CHANGE":
      return payload.newName;
    default:
      return null;
  }
}
